var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTemplateList(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 204,
    height: 153,
    viewBox: "0 0 204 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 204,
    height: 153,
    fill: "#C4C4C4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 83,
    height: 8,
    transform: "translate(60.5 11.5)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 166,
    height: 112,
    transform: "translate(19 29.5)",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 33.5,
    width: 40,
    height: 5,
    rx: 2.5,
    fill: "#C4C4C4"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 33.5,
    width: 20,
    height: 5,
    rx: 2.5,
    fill: "#C4C4C4"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 33.5,
    width: 22,
    height: 5,
    rx: 2.5,
    fill: "#C4C4C4"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 33.5,
    width: 46,
    height: 5,
    rx: 2.5,
    fill: "#C4C4C4"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 42.5,
    width: 40,
    height: 5,
    rx: 2.5,
    fill: "#C4C4C4"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 42.5,
    width: 20,
    height: 5,
    rx: 2.5,
    fill: "#C4C4C4"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 42.5,
    width: 22,
    height: 5,
    rx: 2.5,
    fill: "#C4C4C4"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 42.5,
    width: 46,
    height: 5,
    rx: 2.5,
    fill: "#C4C4C4"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 51.5,
    width: 40,
    height: 5,
    rx: 2.5,
    fill: "#C4C4C4"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 51.5,
    width: 20,
    height: 5,
    rx: 2.5,
    fill: "#C4C4C4"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 51.5,
    width: 22,
    height: 5,
    rx: 2.5,
    fill: "#C4C4C4"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 51.5,
    width: 46,
    height: 5,
    rx: 2.5,
    fill: "#C4C4C4"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 60.5,
    width: 40,
    height: 5,
    rx: 2.5,
    fill: "#C4C4C4"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 60.5,
    width: 20,
    height: 5,
    rx: 2.5,
    fill: "#C4C4C4"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 60.5,
    width: 22,
    height: 5,
    rx: 2.5,
    fill: "#C4C4C4"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 60.5,
    width: 46,
    height: 5,
    rx: 2.5,
    fill: "#C4C4C4"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 69.5,
    width: 40,
    height: 5,
    rx: 2.5,
    fill: "#C4C4C4"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 69.5,
    width: 20,
    height: 5,
    rx: 2.5,
    fill: "#C4C4C4"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 69.5,
    width: 22,
    height: 5,
    rx: 2.5,
    fill: "#C4C4C4"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 69.5,
    width: 46,
    height: 5,
    rx: 2.5,
    fill: "#C4C4C4"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 78.5,
    width: 40,
    height: 5,
    rx: 2.5,
    fill: "#C4C4C4"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 78.5,
    width: 20,
    height: 5,
    rx: 2.5,
    fill: "#C4C4C4"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 78.5,
    width: 22,
    height: 5,
    rx: 2.5,
    fill: "#C4C4C4"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 78.5,
    width: 46,
    height: 5,
    rx: 2.5,
    fill: "#C4C4C4"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 87.5,
    width: 40,
    height: 5,
    rx: 2.5,
    fill: "#C4C4C4"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 87.5,
    width: 20,
    height: 5,
    rx: 2.5,
    fill: "#C4C4C4"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 87.5,
    width: 22,
    height: 5,
    rx: 2.5,
    fill: "#C4C4C4"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 87.5,
    width: 46,
    height: 5,
    rx: 2.5,
    fill: "#C4C4C4"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 96.5,
    width: 40,
    height: 5,
    rx: 2.5,
    fill: "#C4C4C4"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 96.5,
    width: 20,
    height: 5,
    rx: 2.5,
    fill: "#C4C4C4"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 96.5,
    width: 22,
    height: 5,
    rx: 2.5,
    fill: "#C4C4C4"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 96.5,
    width: 46,
    height: 5,
    rx: 2.5,
    fill: "#C4C4C4"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 105.5,
    width: 40,
    height: 5,
    rx: 2.5,
    fill: "#C4C4C4"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 105.5,
    width: 20,
    height: 5,
    rx: 2.5,
    fill: "#C4C4C4"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 105.5,
    width: 22,
    height: 5,
    rx: 2.5,
    fill: "#C4C4C4"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 105.5,
    width: 46,
    height: 5,
    rx: 2.5,
    fill: "#C4C4C4"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 114.5,
    width: 40,
    height: 5,
    rx: 2.5,
    fill: "#C4C4C4"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 114.5,
    width: 20,
    height: 5,
    rx: 2.5,
    fill: "#C4C4C4"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 114.5,
    width: 22,
    height: 5,
    rx: 2.5,
    fill: "#C4C4C4"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 114.5,
    width: 46,
    height: 5,
    rx: 2.5,
    fill: "#C4C4C4"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 123.5,
    width: 40,
    height: 5,
    rx: 2.5,
    fill: "#C4C4C4"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 123.5,
    width: 20,
    height: 5,
    rx: 2.5,
    fill: "#C4C4C4"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 123.5,
    width: 22,
    height: 5,
    rx: 2.5,
    fill: "#C4C4C4"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 123.5,
    width: 46,
    height: 5,
    rx: 2.5,
    fill: "#C4C4C4"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 132.5,
    width: 40,
    height: 5,
    rx: 2.5,
    fill: "#C4C4C4"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 132.5,
    width: 20,
    height: 5,
    rx: 2.5,
    fill: "#C4C4C4"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 132.5,
    width: 22,
    height: 5,
    rx: 2.5,
    fill: "#C4C4C4"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 132.5,
    width: 46,
    height: 5,
    rx: 2.5,
    fill: "#C4C4C4"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplateList);
export default __webpack_public_path__ + "static/media/TemplateList.1419026184dcb8c76f1edacfdfa03580.svg";
export { ForwardRef as ReactComponent };